/* Home-page interactions that cannot live inline: a bare <script> in a
 * Horizon section does not run reliably (see sections/d2-sticky.liquid), so
 * the home hero loads this file instead. Everything in here no-ops when its
 * markup is absent, which is what keeps it home-only without any routing.
 */
(function () {
  'use strict';
  /* The transparent-start flip moved to assets/d2-header.js on 8-29: the
   * header grew Rhode's three-state machine (clear / hidden / solid) and
   * exactly one script may own those classes. This file keeps the home-only
   * furniture — the shade dots and the UGC rail below. */
})();

/* Shade-row pagination dots (the reference's swipe cue). The row only
 * scrolls on the phone — when it fits, the dots stay hidden by the desktop
 * media query and this no-ops beyond the first paint. */
(function () {
  'use strict';

  var row = document.querySelector('.d2-shades__row');
  var dots = document.querySelector('[data-shade-dots]');
  if (!row || !dots) return;

  var pips = dots.querySelectorAll('i');
  if (pips.length < 2) return;

  var ticking = false;

  function paint() {
    ticking = false;
    var track = row.scrollWidth - row.clientWidth;
    var idx = track > 4 ? Math.round((row.scrollLeft / track) * (pips.length - 1)) : 0;
    for (var i = 0; i < pips.length; i++) {
      pips[i].classList.toggle('is-on', i === idx);
    }
  }

  row.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(paint);
      }
    },
    { passive: true }
  );

  paint();
})();

/* UGC row furniture (Leo 8-29: "two ways — click, or drag"). The rail fills
 * with the scroll; the arrows step one tile. Hidden whenever the row has
 * nothing to scroll, so the desktop only shows it while the tiles overflow. */
(function () {
  'use strict';

  var row = document.querySelector('.d2-hugc__row');
  var nav = document.querySelector('[data-ugc-nav]');
  if (!row || !nav) return;

  var bar = nav.querySelector('[data-ugc-bar]');
  var prev = nav.querySelector('[data-ugc-prev]');
  var next = nav.querySelector('[data-ugc-next]');
  var ticking = false;

  function paint() {
    ticking = false;
    var track = row.scrollWidth - row.clientWidth;
    if (track <= 4) {
      nav.hidden = true;
      return;
    }
    nav.hidden = false;
    /* Rhode's rail is a moving drag, not a fill: the bar's width is the
       viewport's share of the content, and it travels the rail with the
       scroll — so it reads as "where you are", visible from the start. */
    var ratio = row.clientWidth / row.scrollWidth;
    var f = Math.max(0, Math.min(1, row.scrollLeft / track));
    bar.style.width = ratio * 100 + '%';
    bar.style.transform = 'translateX(' + ((f * (1 - ratio) / ratio) * 100).toFixed(2) + '%)';
    prev.disabled = row.scrollLeft <= 4;
    next.disabled = row.scrollLeft >= track - 4;
  }

  function step(dir) {
    var tile = row.firstElementChild;
    var gap = 10;
    var w = tile ? tile.getBoundingClientRect().width + gap : row.clientWidth * 0.8;
    row.scrollBy({ left: dir * w, behavior: 'smooth' });
  }

  prev.addEventListener('click', function () { step(-1); });
  next.addEventListener('click', function () { step(1); });

  row.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(paint);
      }
    },
    { passive: true }
  );
  window.addEventListener('resize', paint);

  paint();
})();
